module.exports = "<div id=\"extr-page\">\r\n  <router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/auth-layout.component.html
// module id = 868
// module chunks = 29